import { Box, Divider, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { getBestPracticesData } from "./Data/tg-best-practices-data";
import TgBestPracticeSection from "./Section/TgBestPracticeSection";
import styles from "./TgBestPracticesContent.module.scss";

type Props = {
	hideHeader?: boolean;
};

const TgBestPracticesContent = ({ hideHeader }: Props) => {
	const { t } = useTranslation("tg", { keyPrefix: "bestPractices.content" });
	const data = getBestPracticesData(t);
	const { t: tPopup } = useTranslation("tg", { keyPrefix: "models.popups.bestPractices" });

	return (
		<Box className={styles.root}>
			{!hideHeader && <Typography className={styles.header}>{tPopup("header")}</Typography>}

			<TgBestPracticeSection
				id={tPopup("taps.overview.id")}
				title={t("overviewSection.title")}
				description={t("overviewSection.descr")}
				className={styles.overviewSection}
			/>
			<Divider className={styles.sectionDivider} />

			<TgBestPracticeSection
				id={tPopup("taps.datasetSize.id")}
				title={t("datasetSizeSection.title")}
				list={[
					t("datasetSizeSection.listItem1"),
					t("datasetSizeSection.listItem2"),
					t("datasetSizeSection.listItem3"),
				]}
				className={styles.datasetSizeSection}
			/>
			<Divider className={styles.sectionDivider} />

			<TgBestPracticeSection
				id={tPopup("taps.diversityAndFocus.id")}
				title={t("diversitySection.title")}
				useCases={data.diversityUseCases}
				className={styles.diversitySection}
			/>
			<Divider className={styles.sectionDivider} />

			<TgBestPracticeSection
				title={t("imageQualitySection.title")}
				description={t("imageQualitySection.descr")}
				useCases={data.imageQualityUseCases}
				id={tPopup("taps.imageQuality.id")}
			/>
			<Divider className={styles.sectionDivider} />

			<TgBestPracticeSection
				title={t("assetsSection.title")}
				description={t("assetsSection.descr")}
				subTitle={t("assetsSection.subTitle")}
				useCases={data.assetsUseCases}
				id={tPopup("taps.assetsBackgrounds.id")}
			/>
			<Divider className={styles.sectionDivider} />

			<TgBestPracticeSection
				title={t("captionsSection.title")}
				description={t("captionsSection.descr")}
				useCases={data.captionsUseCases}
				id={tPopup("taps.captionsAndPrefix.id")}
			/>
			<Divider className={styles.sectionDivider} />

			<TgBestPracticeSection
				title={t("restylePortraits.title")}
				useCases={data.restylePortraits}
				id={tPopup("taps.restylePortraits.id")}
				hideDivider={true}
			/>
		</Box>
	);
};

export default observer(TgBestPracticesContent);
